module.exports = __webpack_public_path__ + "static/media/icrisat.fb2bf437.png";